import { Settings, Trash2 } from "lucide-react";
import type { FC } from "react";

import { FormSection } from "@/components/form";
import { Button } from "@/components/ui/button";

import type { CaseSettingsForm } from "../useCaseSettingsForm";

export const DataManagementSection: FC<{ form: CaseSettingsForm }> = ({
  form
}) => (
  <div className="flex h-full min-h-0 w-full flex-col overflow-hidden bg-background">
    <div className="flex min-h-0 w-full flex-1 flex-col items-start overflow-auto">
      <FormSection
        variant="band"
        icon={Settings}
        title="Data Management"
        className="[&>div:first-child]:border-t-0"
      >
        <div className="flex w-full flex-wrap items-start gap-4">
          <div className="flex min-w-0 max-w-130 flex-col gap-0.5">
            <span className="text-sm font-semibold text-foreground">
              Delete case
            </span>
            <span className="text-xs text-muted-foreground">
              This action cannot be undone.
            </span>
          </div>
          <div className="ml-auto">
            <Button
              type="button"
              variant="destructive"
              onClick={form.openDeleteDialog}
              disabled={!form.isReady || form.isSaving || form.isDeleting}
            >
              <Trash2 />
              Delete case
            </Button>
          </div>
        </div>
      </FormSection>
    </div>
  </div>
);
